import { createMiddleware } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";
import type { auth } from "../../auth/auth";

type AuthUser = Omit<typeof auth.$Infer.Session.user, "role"> & {
  userId: string;
  role: "user" | "admin";
};

export const optionalAuthMiddlewareServer = createMiddleware({
  type: "function",
}).server(async ({ next }) => {
  const nextWithAuth = (authUser?: AuthUser) =>
    next({
      context: {
        auth: authUser,
      },
    });

  try {
    const { auth } = await import("../../auth/auth");
    const headers = getRequestHeaders();
    const session = await auth.api.getSession({
      headers,
    });

    if (!session) {
      return nextWithAuth(undefined);
    }

    return nextWithAuth({
      ...session.user,
      userId: session.user.id,
      role: (session.user as typeof session.user & { role: "user" | "admin" })
        .role,
    } as AuthUser);
  } catch (e) {
    console.error("[optionalAuth] Session kontrolunde hata:", e);
    return nextWithAuth(undefined);
  }
});
